import { render, staticRenderFns } from "./systemUpdateNotice.vue?vue&type=template&id=3b6bd5cc&scoped=true"
import script from "./systemUpdateNotice.vue?vue&type=script&lang=js"
export * from "./systemUpdateNotice.vue?vue&type=script&lang=js"
import style0 from "./systemUpdateNotice.vue?vue&type=style&index=0&id=3b6bd5cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6bd5cc",
  null
  
)

export default component.exports